import { Component, Input, OnInit } from '@angular/core';
import { Product } from '../../product';
import { CategoryService } from '../../../main-shared/categories-display/category.service';
import { Observable, of } from 'rxjs';
import { Category } from '../../../main-shared/categories-display/category';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-product-details-categories',
  templateUrl: './product-details-categories.component.html',
  styleUrls: ['./product-details-categories.component.scss'],
})
export class ProductDetailsCategoriesComponent implements OnInit {
  @Input() product: Product | undefined;
  categories$: Observable<Category[]> = of([]);

  constructor(private readonly categoryService: CategoryService) {}

  ngOnInit(): void {
    if (this.product && this.product?.categories) {
      this.categories$ = this.categoryService
        .getAllCached()
        .pipe(
          map((categories) =>
            this.getProductCategories(categories, this.product!)
          )
        );
    }
  }

  getProductCategories(categories: Category[], product: Product): Category[] {
    const productCategories: Category[] = [];
    product.categories.forEach((id) => {
      const found = this.categoryService.getCategoryByIDFromCache(
        categories,
        id
      );
      if (found) {
        productCategories.push(found);
      }
    });
    return productCategories;
  }
}
